import SideMenu from '../../components/side-menu/SideMenu';
import React, {useEffect, useState} from 'react';
import TransformationHeaderArea from './components/TransformationHeaderArea';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';
import {PaddingColor, TransformValues} from '../../utils/helper';
import {useNavigate, useParams} from 'react-router-dom';
import {getFileMetaData, saveImageMediaFile} from '../../actions/pure/media';
import {FileData} from '../../reducers/media';
import {BulkChangeLogs} from './components/BulkChangeLogs';
import {Dialog, DialogContent, DialogHeader} from '../../ui-components/Modal';
import BulkImageUploading from '../../components/bulk-image-uploading/BulkImageUploading';
import {DEFAULT_IMG_HOST} from '../../constants';
import {Button} from '../../ui-components/Button/button';

interface UrlValueMapping {
    toAppendValue: string | undefined;
    actualValue?: string | boolean | number;
}
interface urlProps {
    format?: UrlValueMapping;
    quality?: UrlValueMapping;
    height?: UrlValueMapping;
    width?: UrlValueMapping;
    padding?: UrlValueMapping;
    paddingColor?: UrlValueMapping;
    bgRemoved?: UrlValueMapping;
    greyScale?: UrlValueMapping;
    bgImageUid?: UrlValueMapping;
    bgColor?: UrlValueMapping;
    rotation?: UrlValueMapping;
    blur?: UrlValueMapping;
}

interface ModifiedDataCdn {
    modifiedUrl: string;
    imageUid: string;
}
export default function BulkTransformation() {
    const {fileUids} = useParams();

    const [width, setWidth] = useState('');
    const [height, setHeight] = useState('');
    const [blur, setBlur] = useState<number>();
    const [enablePadding, setPadding] = useState(false);
    const [isGreyToneApplied, setGreyToneApplied] = useState(false);
    const [imageFormat, setImageFormat] = useState('');
    const [quality, setQuality] = useState<string>('');
    const [fileData, setFileData] = useState<FileData[]>();
    const [isBgRemoved, setBgRemoved] = useState(false);
    const [showImageSaving, setShowImageSaving] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [errorOccurred, setErrorOccurred] = useState(false);
    const [svgOrGifWarning, setSvgOrGifWarning] = useState(false);
    const [rotation, setRotation] = useState<number>();
    const [modifiedCdnUrl, setModifiedCdnUrl] = useState<ModifiedDataCdn[]>();

    const [urlTransformation, setUrlTransformation] = useState<urlProps>({});
    const [transformationObject, setTransformationObject] = useState<TransformValues>({});

    const [userProfileProps, settingsProps] = [
        useSelector((state: RootState) => state.userProfile),
        useSelector((state: RootState) => state.settings),
    ];

    const orgUid = userProfileProps.currentOrganization.uid;
    const navigate = useNavigate();

    const backgroundRemoveActions = () => {
        setBgRemoved(!isBgRemoved);
    };

    const rotateImage = (angle: number) => {
        setRotation(angle);
    };

    const onTransformValuesChange = (values: TransformValues) => {
        const transformationsToUpdate: urlProps = {};
        const transformationsObj: TransformValues = transformationObject;
        setUrlTransformation({});
        if (values.padding !== undefined && values.padding !== null) {
            if (values.padding) {
                transformationsToUpdate.padding = {toAppendValue: 'c_pad', actualValue: true};
                transformationsObj.padding = true;
                setPadding(true);
            } else {
                transformationsToUpdate.padding = undefined;
                setPadding(false);
            }
        }

        if (values.rotation !== undefined && values.rotation !== null) {
            if (values.rotation !== 0) {
                transformationsToUpdate.rotation = {
                    toAppendValue: `a_${values.rotation}`,
                    actualValue: values.rotation,
                };
                transformationsObj.rotation = values.rotation;
            } else {
                transformationsToUpdate.rotation = {toAppendValue: undefined, actualValue: undefined};
                transformationsObj.rotation = values.rotation;
            }
        }

        if (values.paddingColor && values.paddingColor.padRgb !== undefined && values.paddingColor.padRgb !== null) {
            transformationsToUpdate.paddingColor = {
                toAppendValue: `b_${values.paddingColor.padRgb}`,
                actualValue: values.paddingColor.padHex,
            };
            transformationsObj.paddingColor = {padRgb: values.paddingColor.padRgb, padHex: values.paddingColor.padHex};
        }
        if (values.format) {
            transformationsToUpdate.format = {toAppendValue: `f_${values.format}`, actualValue: values.format};
            transformationsObj.format = values.format;
            setImageFormat(values.format);
        }
        if (values.quality) {
            transformationsToUpdate.quality = {toAppendValue: `q_auto:${values.quality}`, actualValue: values.quality};
            transformationsObj.quality = values.quality;
            setQuality(values.quality);
        }
        if (
            values.width !== undefined &&
            values.width !== null &&
            values.width.length > 0 &&
            parseInt(values.width.trim()) > 0
        ) {
            transformationsToUpdate.width = {toAppendValue: `w_${values.width}`, actualValue: values.width};
            transformationsObj.width = values.width;
            setWidth(values.width);
        }
        if (
            values.height !== undefined &&
            values.height !== null &&
            values.height.length > 0 &&
            parseInt(values.height.trim()) > 0
        ) {
            transformationsToUpdate.height = {toAppendValue: `h_${values.height}`, actualValue: values.height};
            transformationsObj.height = values.height;
            setHeight(values.height);
        }
        if (values.isBgRemoved !== undefined) {
            if (values.isBgRemoved) {
                transformationsToUpdate.bgRemoved = {toAppendValue: `e_bgremoval`, actualValue: values.isBgRemoved};
                transformationsObj.isBgRemoved = values.isBgRemoved;
            } else {
                transformationsToUpdate.bgRemoved = {toAppendValue: undefined, actualValue: undefined};
                transformationsObj.isBgRemoved = false;
            }
        }
        if (values.isGreyToneApplied !== undefined) {
            if (values.isGreyToneApplied) {
                transformationsToUpdate.greyScale = {
                    toAppendValue: `e_grayscale`,
                    actualValue: values.isGreyToneApplied,
                };
                transformationsObj.isGreyToneApplied = true;
                setGreyToneApplied(true);
            } else {
                transformationsToUpdate.greyScale = {toAppendValue: undefined, actualValue: undefined};
                transformationsObj.isGreyToneApplied = false;
                setGreyToneApplied(false);
            }
        }
        if (values.blur !== undefined && values.blur !== null) {
            if (values.blur > 0) {
                setBlur(values.blur);
                transformationsToUpdate.blur = {toAppendValue: `blur_${values.blur}_0.1`, actualValue: values.blur};
                transformationsObj.blur = values.blur;
            } else {
                transformationsToUpdate.blur = {toAppendValue: undefined, actualValue: undefined};
                transformationsObj.blur = 0;
            }
        }
        if (values.bgColorPalette) {
            transformationsToUpdate.bgImageUid = {toAppendValue: undefined, actualValue: undefined};
            transformationsToUpdate.bgRemoved = {toAppendValue: undefined, actualValue: undefined};
            transformationsToUpdate.bgColor = {
                toAppendValue: `i_bgreplace,b_${values.bgColorPalette.substring(1)}`,
                actualValue: values.bgColorPalette,
            };
        }
        if (values.backgroundImageUid) {
            transformationsToUpdate.bgImageUid = {
                toAppendValue: `i_bgreplace,b_uid_${values.backgroundImageUid}`,
                actualValue: values.backgroundImageUid,
            };
            transformationsToUpdate.bgRemoved = {toAppendValue: undefined, actualValue: undefined};
            transformationsToUpdate.bgColor = {toAppendValue: undefined, actualValue: undefined};
            transformationObject.backgroundImageUid = values.backgroundImageUid;
        }
        setTransformationObject(transformationsObj);
        setUrlTransformation((prevState: urlProps) => {
            return {...urlTransformation, ...transformationsToUpdate};
        });
    };
    const addTransformation = () => {};
    const removeTransformation = () => {};

    const saveImage = () => {
        setIsSaving(true);
        setShowImageSaving(true);
        const filesPromises: Promise<any>[] = [];
        setIsSaving(true);
        modifiedCdnUrl?.forEach((image) => {
            const body = {
                orgUid: orgUid,
                mediaFileUid: image.imageUid,
                imageUrl: image.modifiedUrl,
            };
            const promise = saveImageMediaFile(body);
            filesPromises.push(promise);
        });
        Promise.all(filesPromises)
            .then((results) => {
                setIsSaving(false);
                setIsSaved(true);
                navigate(-1);
            })
            .catch((error) => {
                setIsSaving(false);
                setIsSaved(true);
                navigate(-1);
                console.error('Error occurred:', error);
            });
    };
    const handleCloseButton = () => {
        navigate(-1);
    };

    const suspendSaveDialog = () => {
        setShowImageSaving(false);
        setIsSaving(false);
        setIsSaved(false);
        setErrorOccurred(false);
    };

    useEffect(() => {
        let fileUidArray = [];
        const fileMetaPromises: Promise<FileData>[] = [];
        const fileMeta: FileData[] = [];
        let svgGifWarning = false;
        if (fileUids != null) {
            fileUidArray = decodeURIComponent(fileUids).split(',');

            fileUidArray.forEach((uid) => {
                const promise = getFileMetaData({orgUid, fileUid: uid});
                fileMetaPromises.push(promise);
            });
            Promise.all(fileMetaPromises)
                .then((results) => {
                    results.forEach((r) => {
                        if (r.type !== 'svg') {
                            fileMeta.push(r);
                        } else {
                            svgGifWarning = true;
                        }
                    });
                    if (svgGifWarning) {
                        setSvgOrGifWarning(true);
                    }
                    setFileData(fileMeta);
                })
                .catch((error) => {
                    console.error('Error occurred:', error);
                });
        }
    }, []);

    useEffect(() => {
        if (fileData) {
            const modifiedMeta: ModifiedDataCdn[] = [];
            fileData.forEach((data) => {
                modifiedMeta.push({modifiedUrl: data.cdn_url, imageUid: data.uid});
            });
            setModifiedCdnUrl(modifiedMeta);
        }
    }, [fileData]);

    useEffect(() => {
        onTransformValuesChange({rotation: rotation});
    }, [rotation]);

    useEffect(() => {
        if (isBgRemoved) {
            onTransformValuesChange({isBgRemoved: true});
        } else {
            onTransformValuesChange({isBgRemoved: false});
        }
    }, [isBgRemoved]);

    useEffect(() => {
        if (Object.keys(urlTransformation).length > 0) {
            const tempList: ModifiedDataCdn[] = [];

            fileData?.forEach((data, index) => {
                const transformationValues = Object.entries(urlTransformation).filter(
                    ([key, value]) => value !== null && value !== undefined && value !== '' && value !== false,
                );
                if (transformationValues.length > 0) {
                    const concatenatedValues = transformationValues.map(([key, value]) => {
                        const toAppendValue = value?.toAppendValue;
                        if (toAppendValue) {
                            return `${toAppendValue}`;
                        } else {
                            return undefined;
                        }
                    });
                    if (concatenatedValues) {
                        const filteredValues = concatenatedValues.filter((value) => value !== undefined);
                        const concatenatedString = filteredValues.join(',');
                        let modifiedUrlParts = data.cdn_url.split('/');
                        let prefixCount = 4;
                        if (DEFAULT_IMG_HOST && !data.cdn_url.startsWith(DEFAULT_IMG_HOST)) {
                            prefixCount = 3;
                        }
                        const hostPart = modifiedUrlParts.slice(0, prefixCount);
                        const filePath = modifiedUrlParts.slice(prefixCount);
                        const modifiedUrl = hostPart.join('/') + '/' + concatenatedString + '/' + filePath.join('/');
                        tempList.push({modifiedUrl, imageUid: data.uid});
                    }
                }
            });
            if (tempList.length) {
                setModifiedCdnUrl(tempList);
            }
        }
    }, [urlTransformation]);

    return (
        <div className='flex h-[100vh] bg-[#101323]'>
            <SideMenu
                isEmbedded={false}
                onTransformValuesChange={onTransformValuesChange}
                transformationObject={transformationObject}
                addTransformation={addTransformation}
                removeTransformation={removeTransformation}
                isBulkEdit={true}
            />

            <div className='flex w-full flex-col'>
                <TransformationHeaderArea
                    allowBackgroundRemoval={settingsProps.allow_background_removal}
                    backgroundRemoveActions={backgroundRemoveActions}
                    isBgRemoved={isBgRemoved}
                    onRotate={rotateImage}
                    rotation={rotation || 0}
                    isBulkEdit={true}
                    saveImage={saveImage}
                    handleCloseButton={handleCloseButton}
                />
                <div className='flex h-screen max-h-screen justify-between overflow-y-scroll '>
                    <div className='grid grid-cols-5 gap-5 overflow-y-auto px-8'>
                        {modifiedCdnUrl &&
                            modifiedCdnUrl.map((image, index) => (
                                <ImageWithShimmer key={index} imageSrc={image.modifiedUrl} index={index} />
                            ))}
                    </div>
                    <div className={'hidden bg-[#293056] md:flex'}>
                        <BulkChangeLogs
                            bgRemoved={isBgRemoved}
                            dimensionsChanged={!!(width || height)}
                            greyToneApplied={isGreyToneApplied}
                            loading={false}
                            newFileType={imageFormat}
                            fileQuality={quality}
                            rotation={rotation}
                        />
                        {/*</div>*/}
                    </div>
                </div>
            </div>
            <Dialog open={showImageSaving}>
                <DialogContent
                    className='flex w-[333px] px-[40px] py-[22px] md:w-[1160px] md:px-10 md:py-10'
                    onClose={suspendSaveDialog}>
                    <BulkImageUploading
                        imageData={transformationObject}
                        isSaving={isSaving}
                        isSaved={isSaved}
                        orgUid={userProfileProps.currentOrganization.uid}
                        errorOccurred={errorOccurred}
                        onClose={suspendSaveDialog}
                        retrySave={saveImage}
                    />
                </DialogContent>
            </Dialog>
            <Dialog open={svgOrGifWarning}>
                <DialogContent
                    className='flex w-[686px] flex-col px-[40px] py-[22px]'
                    onClose={() => setSvgOrGifWarning(false)}>
                    <DialogHeader className='font-[600]'>SVG / GIF format is not supported in bulk edit</DialogHeader>
                    <span>Would you like to continue editing without these images?</span>
                    <div className='mt-8 flex justify-between gap-3'>
                        <Button variant='secondary' size='lg' className='w-full' onClick={() => navigate(-1)}>
                            Cancel
                        </Button>
                        <Button size='lg' className='w-full' onClick={() => setSvgOrGifWarning(false)}>
                            Continue
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}

const ImageWithShimmer = ({imageSrc, index}: {imageSrc: string; index: number}) => {
    const [loading, setLoading] = useState(true);
    const [image, setImage] = useState<string>();

    const onLoad = () => {
        setLoading(false);
    };

    useEffect(() => {
        setLoading(true);
        setImage(imageSrc);
    }, [imageSrc]);

    return (
        <div className='relative'>
            {loading && (
                <div className='h-[190px] w-[190px] animate-pulse rounded-[1rem] border-[1px] border-[#2B335D] bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200'></div>
            )}
            <img
                src={image}
                alt={`${index}`}
                className={`h-[190px] w-[190px] rounded-[1rem] border-[1px] border-[#2B335D] object-cover ${loading ? 'hidden' : ''}`}
                onLoad={onLoad}
            />
        </div>
    );
};
